import { parse } from 'csv-parse/sync';
import validate from 'utils/validate';
import map from 'lodash/map';
import forEach from 'lodash/map';
import isNaN from 'lodash/isNaN';

const validators = {
    // TODO: Apply validation like so: name and either address or lat/long pair
    locationName() {},
    address(value, source) {
        if (source.lat && source.long && value === '') {
            return;
        }

        if (!value) {
            return 'a valid address is required';
        }
    },
    city() {},
    postalCode(value) {
        if (!/[a-z][0-9][a-z]\s?[0-9][a-z][0-9]/i.test(value)) {
            return 'Invalid postal code format. Only Canadian addresses are accepted at this time';
        }
    },
    country(value) {
        if (!/canada/i.test(value) || !/ca/i.test(value)) {
            return 'Invalid country name. Only Canadian addresses are accepted at this time';
        }
    },
    lat(value, source) {
        const isLatitudeRequired = !source.address;

        if (!isLatitudeRequired && value === '') return;

        if (!value) {
            return 'a latitude is required';
        }

        const latitude = Number(value);

        if (isNaN(latitude)) {
            return 'a valid latitude is required';
        }

        if (latitude < -90 || latitude > 90) {
            return 'a latitude must be between -90 and 90 degrees.';
        }
    },
    long(value, source) {
        const isLongitudeRequired = !source.address;

        if (!isLongitudeRequired && value === '') return;

        if (!value) {
            return 'a longitude is required';
        }

        const longitude = Number(value);

        if (isNaN(longitude)) {
            return 'a valid longitude is required';
        }

        if (longitude < -180 || longitude > 180) {
            return 'a longitude must be between -180 and 180 degrees.';
        }
    },
};

export function validateLocations(csvText) {
    let parsedCsv;
    try {
        parsedCsv = parse(csvText, { columns: true });
        parsedCsv = filterParsedCsv(parsedCsv);
        if (!parsedCsv || parsedCsv.length === 0) {
            throw new Error('CSV is empty or has wrong formatting!');
        }
    } catch (e) {
        console.error('Error parsing CSV: ', e);
        return ['Invalid CSV submitted with error:', e.message];
    }

    const errors = {};
    forEach(parsedCsv, locationData => {
        let lineErrors = validate(locationData, validators);
        const locationKey = `${locationData.lat}_${locationData.long}_${locationData.address}`;

        forEach(lineErrors, error => {
            const condensedError = `Invalid ${error.field} - ${error.message}`;
            errors[locationKey] = { ...error, message: condensedError };
        });
    });

    return Object.keys(errors).length ? errors : {};
}

export function constructLocations(csvText) {
    let parsedCsv = parse(csvText, { columns: true });
    parsedCsv = filterParsedCsv(parsedCsv);

    return map(parsedCsv, record => ({
        locationName: record.locationName,
        address: record.address,
        city: record.city,
        postalCode: record.postalCode,
        country: record.country,
        lat: record.lat,
        long: record.long,
        locationKey: `${record.lat}_${record.long}_${record.address}`,
    }));
}

function filterParsedCsv(csv) {
    return csv.filter(
        record =>
            record.locationName !== '' &&
            record.city !== '' &&
            record.postalCode !== '' &&
            record.country !== ''
    );
}

export function filterEmptyRawCsvLocations(csv) {
    const records = csv.split('\n');

    const nonEmptyRecords = records.filter(record => record.trim() !== ',,,,,,');

    return nonEmptyRecords.join('\n');
}
